import { render, staticRenderFns } from "./EditEventLocationPage.vue?vue&type=template&id=275af46c&"
import script from "./EditEventLocationPage.vue?vue&type=script&lang=js&"
export * from "./EditEventLocationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports